<template>
  <div class="about">
    <div class="title-content">
      <h1>Galeria</h1>
      <br />
      <p>
        Quer ver seu desenho, vídeo ou redação em nossa galeria? Envie sua
        produção artística mostrando o que mais chamou sua a atenção em nossos
        vídeos e teremos prazer em publicá-la por aqui.
        <br />
        <br />
        Professor, incentive e auxilie seus alunos com as produções e nos envie
        para divulgação aqui!
      </p>
    </div>
    <div
      class="pt-10 pb-2 my-10 bg-orange fit-width"
      style="box-shadow: 0 0 8px 0px #0000004a"
    >
      <carousel :settings="carouselSettings">
        <slide v-for="(arte, idx) in galeria" :key="idx">
          <content-card :caption="arte.autor" :label="arte.titulo">
            <template v-slot:image>
              <img
                :src="arte.imagem"
                style="width: 700px; transform: scale(1.1)"
                @click="selcionarArte(arte)"
              />
            </template>
          </content-card>
        </slide>
      </carousel>
    </div>

    <div class="galeria-items-container">
      <content-card
        v-for="(arte, idx) in galeria"
        :key="idx"
        :caption="arte.autor"
        :label="arte.titulo"
      >
        <template v-slot:image>
          <img
            :src="arte.imagem"
            style="height: 213px; transform: scale(1.1)"
            @click="selcionarArte(arte)"
          />
        </template>
      </content-card>
    </div>

    <modal-base v-model:show="exibirArte">
      <div v-if="arteSelecionada != null">
        <img :src="arteSelecionada.imagem" />
        <div class="text-left text-lg font-base caption mt-2">
          {{ arteSelecionada.autor }}
        </div>
        <div class="text-left text-lg font-bold">
          {{ arteSelecionada.titulo }}
        </div>
      </div>
    </modal-base>
  </div>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide } from "vue3-carousel";
import ContentCard from "../components/common/ContentCard.vue";
import ModalBase from "../components/common/ModalBase.vue";

export default {
  components: { ContentCard, Carousel, Slide, ModalBase },
  data() {
    return {
      exibirArte: false,
      carouselSettings: {
        itemsToShow: 1,
        autoplay: 1000 * 5,
        wrapAround: true,
        transition: 500,
      },
      galeria: [
        // { autor: 'João Lucas, 10 anos', titulo: 'Olhe bem antes de mergulhar', imagem: require('../assets/galeria/arte_1.png') },
        {
          autor: "João, 10 anos",
          titulo: "Cuidado na avenida",
          imagem: require("../assets/galeria/texto_2.png"),
        },
        {
          autor: "João, 10 anos",
          titulo: "Acidente na primeira infância",
          imagem: require("../assets/galeria/texto_3.png"),
        },
        {
          autor: "Anita, 10 anos",
          titulo: "Prevenção de acidentes",
          imagem: require("../assets/galeria/texto_4.png"),
        },
        {
          autor: "João, 10 anos",
          titulo: "Cuidado na avenida",
          imagem: require("../assets/galeria/arte_2.png"),
        },
        //
        {
          autor: "Ester, 11 anos",
          titulo: "Fisioterapia",
          imagem: require("../assets/galeria/arte_6.jpg"),
        },
        {
          autor: "Isabela, 11 anos",
          titulo: "A Rede Sarah",
          imagem: require("../assets/galeria/arte_3.jpg"),
        },
        {
          autor: "Sofia, 8 anos",
          titulo: "Cadeiras de Rodas",
          imagem: require("../assets/galeria/arte_4.jpg"),
        },
        {
          autor: "Anna, 9 anos",
          titulo: "Cadeira de Rodas",
          imagem: require("../assets/galeria/arte_5.jpg"),
        },
      ],
      arteSelecionada: null,
    };
  },
  methods: {
    selcionarArte(arte) {
      this.arteSelecionada = arte;
      this.exibirArte = true;
    },
  },
  mounted() {
    this.$smoothScroll({
      scrollTo: 0,
      updateHistory: false,
    });
  },
};
</script>

<style>
.about .bg-orange,
.about .bg-orange .caption {
  color: #fff !important;
}

@media (min-width: 1020px) {
  .galeria-items-container {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 5rem;
  }
}
</style>
